import { render, staticRenderFns } from "./ReturnOrders.vue?vue&type=template&id=208cab64&"
import script from "./ReturnOrders.vue?vue&type=script&lang=js&"
export * from "./ReturnOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtnDropdown,QTable,QSelect,QInput,QBtn,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtnDropdown,QTable,QSelect,QInput,QBtn,QTr,QTh,QTd})
